import React from "react";

/**
 * Pelico Data brand mark + wordmark.
 * dark=true → for navy backgrounds (PELICO in white); otherwise PELICO in navy.
 */
export default function BrandLogo({ size = "md", dark = false, showMark = true, className = "" }) {
  const dims = { sm: "w-7 h-7", md: "w-8 h-8", lg: "w-10 h-10" }[size] || "w-8 h-8";
  const text = { sm: "text-base", md: "text-lg", lg: "text-xl sm:text-2xl" }[size] || "text-lg";
  return (
    <span data-testid="brand-logo-mark" className={`inline-flex items-center gap-2 ${className}`}>
      {showMark && (
        <img src="/logo192.png" alt="Pelico Data" className={`${dims} rounded-lg shadow-sm shrink-0`} />
      )}
      <span className={`font-display font-bold tracking-tight whitespace-nowrap ${text}`}>
        <span className={dark ? "text-white" : "text-[var(--ink)]"}>PELICO</span>
        <span className={dark ? "text-[var(--gold)]" : "text-[var(--accent)]"}> DATA</span>
      </span>
    </span>
  );
}
